import bgs from './bgs.module.scss'
import styles from './ColoredText.module.scss'
import colors from './colors.module.scss'

export const ColoredText = ({ children, level, onClick }) => (
  <span
    className={[onClick ? styles.clickable : '', colors[level]].join(' ')}
    onClick={onClick}
  >
    {children}
  </span>
)

export const BgText = ({ children, level }) => (
  <span className={bgs[level]}>{children}</span>
)
